import { FC, useEffect, useRef } from 'react';
import { AddressSuggestions, DaDataSuggestion, DaDataAddress } from 'react-dadata';
import 'react-dadata/dist/react-dadata.css';
import './react-address-dadata.scss';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { setErrorStatusField, setWasChanges } from 'redux/mainInfo/slice';
import { setInfoProfileCreate } from 'redux/createProfile/slice';

interface AddressDadataReg {
  placeholder: string;
  objKey: string;
  value?: DaDataSuggestion<DaDataAddress> | undefined;
  onChange?: (value: DaDataSuggestion<DaDataAddress> | undefined) => void;
  error?: boolean;
}

export const AddressDadataReg: FC<AddressDadataReg> = ({
  placeholder,
  objKey,
  value,
  onChange,
  error,
}) => {
  const { jur_address } = useSelector((state: RootState) => state.createProfile);
  const suggestionsRef = useRef<AddressSuggestions>(null);
  const dispatch = useDispatch();

  // Создаем безопасное значение
  const safeValue: DaDataSuggestion<DaDataAddress> | undefined = value || undefined;

  useEffect(() => {
    if (objKey && value?.value) {
      dispatch(setErrorStatusField({ key: objKey, value: 0 }));
    }
    if (value?.value) {
      dispatch(setInfoProfileCreate({ key: objKey, value: value.value }));
      dispatch(setWasChanges(true));
    }
  }, [value, objKey, dispatch]);

  useEffect(() => {
    if (objKey === 'jur_address' && suggestionsRef.current && jur_address) {
      suggestionsRef.current.setInputValue(jur_address);
      dispatch(setWasChanges(true));
    }
  }, [objKey, jur_address, dispatch]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value.trimStart();

    // Если поле очищается, сбрасываем значение в форме
    if (!newValue && onChange) {
      onChange(undefined);
    }
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (!e.target.value.trimStart() && objKey) {
      dispatch(setErrorStatusField({ key: objKey, value: 1 }));
    }
  };

  return (
    <AddressSuggestions
      ref={suggestionsRef}
      token={`${process.env.REACT_APP_API_KEY}`}
      value={safeValue}
      onChange={onChange}
      containerClassName='react-dadata react-dadata__container address-dadata-reg'
      inputProps={{
        placeholder: placeholder,
        onChange: handleInputChange,
        onBlur: handleBlur,
        ...(error ? { className: 'react-dadata__input react-dadata__input_error' } : {}),
      }}
    />
  );
};
